module.exports = __webpack_public_path__ + "img/1.88faaa22.jpg";